import { render } from "react-dom"
import * as React from "elm-ts/lib/React"
import { pipe } from "fp-ts/function"
import { programWithDebugger } from "elm-ts/lib/Debug/Navigation"
import { program } from "elm-ts/lib/Navigation"
import { Model, Msg } from "./Model"
import { init, update } from "./Update"
import { view } from "./View"
import * as O from "fp-ts/Option"
import * as rxjs from "rxjs"
import { firebaseAuth } from "./Authorization"
import { User } from "firebase/auth"
import * as sub from "elm-ts/lib/Sub"
import * as runtimeVariables from "./runtimeVariables"
import initSentry from "./Sentry"

import "./styles/fonts.css"
import "./styles/tailwind.scss"
import "./styles/theme.scss"

initSentry(runtimeVariables.SENTRY_ENABLED)

const authStateSubject: rxjs.Subject<O.Option<User>> = new rxjs.Subject<
  O.Option<User>
>()
firebaseAuth.onAuthStateChanged(user => {
  authStateSubject.next(O.fromNullable(user))
})

const subscriptions: (model: Model) => sub.Sub<Msg> = () => {
  return sub.batch([sub.map(Msg.authStateChangedMsg)(authStateSubject)])
}

const main = pipe(
  runtimeVariables.PROGRAM === "debugger" ? programWithDebugger : program,
  program => program(Msg.navigationMsg, init, update, view, subscriptions)
)

React.run(main, dom => render(dom, document.getElementById("app")))
